import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { TWO_FA_REQUIRED_LENGTH } from 'components/TwoFA/TwoFAField'

interface UseTwoFactorValidationReturn {
  twoFactorCode: string
  validationError: string
  handleCodeChange: (code: string) => void
  validateCode: () => boolean
  resetValidation: () => void
}

export const useTwoFactorValidation = (): UseTwoFactorValidationReturn => {
  const { t } = useTranslation()
  const [twoFactorCode, setTwoFactorCode] = useState('')
  const [validationError, setValidationError] = useState('')

  const handleCodeChange = (code: string) => {
    setTwoFactorCode(code)
    if (validationError) {
      setValidationError('')
    }
  }

  const validateCode = (): boolean => {
    if (!twoFactorCode) {
      setValidationError(t('2faEmptyError'))
      return false
    }

    if (twoFactorCode.length !== TWO_FA_REQUIRED_LENGTH) {
      setValidationError(t('2faWrongLengthError'))
      return false
    }

    return true
  }

  const resetValidation = () => {
    setTwoFactorCode('')
    setValidationError('')
  }

  return {
    twoFactorCode,
    validationError,
    handleCodeChange,
    validateCode,
    resetValidation,
  }
}
